import React, {PureComponent} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './style.scss'
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";

export default class DeleteOrdersConfirmationDialog extends PureComponent {
    constructor(props) {
        super(props);
    }

    handleCancel() {
        if (this.props.onCancel)
            this.props.onCancel();
    }

    handleDelete() {
        if (this.props.onDelete)
            this.props.onDelete();
    }

    render() {
        return (
            <Dialog
                className="sms-confirmation-dialog"
                open={this.props.open}
                onClose={this.handleCancel.bind(this)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">אישור מחיקת הזמנות</DialogTitle>
                <DialogContent>
                    <div>
                        האם אתה בטוח שברצונך למחוק הזמנות מהעסק {this.props.bid}?
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={this.handleCancel.bind(this)}>
                        בטל
                    </Button>
                    <Button variant="contained" color="primary" onClick={this.handleDelete.bind(this)}>
                        בטוח
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}